var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkAsIrrelevant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,2A11,11,0,1,0,24,13,11,11,0,0,0,13,2Zm0,19.8A8.8,8.8,0,0,1,4.2,13,8.693,8.693,0,0,1,6.059,7.61L18.39,19.941A8.693,8.693,0,0,1,13,21.8Zm6.941-3.41L7.61,6.059A8.693,8.693,0,0,1,13,4.2,8.8,8.8,0,0,1,21.8,13,8.693,8.693,0,0,1,19.941,18.39Z",
    transform: "translate(-2 -2)",
    fill: "#c6c9d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsIrrelevant);
export default __webpack_public_path__ + "static/media/mark-as-Irrelevant.e955b5358afe88f76010530837e7b7c2.svg";
export { ForwardRef as ReactComponent };